<template>
  <div class="uk-modal" uk-modal>
    <div id="informationForDynamic">
      <div class="uk-modal-dialog bggray information-modal">
        <div class="uk-modal-body">
          <div v-if="loading" class="text-center py-5">
            <span uk-spinner="ratio: 2"></span>
            <p class="mt-3">{{ $t('general.loading') }}...</p>
          </div>
          <div v-else-if="legalTextsData && Object.keys(legalTextsData).length" class="information-content">
            <div class="legal-section mb-4">
              <h1>{{ legalTextsData.kvkk_notice.title }}</h1>
              <div v-html="legalTextsData.kvkk_notice.html"></div>
            </div>
          </div>
          <div v-else class="text-center py-5">
            <p>{{ $t('general.no_data') }}</p>
          </div>
        </div>
        <div class="uk-modal-footer uk-text-right bggray">
          <button class="uk-button uk-button-default small uk-modal-close" type="button">
            <i class="uil-times"></i> {{ $t("general.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/core/services";
import i18nService from "@/core/services/i18n.service.js";
import company_module, {
  MODULE_NAME as COMPANY_MODULE_NAME,
} from "@/core/services/store/company.module";

export default {
  name: "informationModal",

  data() {
    return {
      legalTextsData: {},
      loading: false,
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(COMPANY_MODULE_NAME, company_module);
  },

  computed: {
    company() {
      return store.getters[COMPANY_MODULE_NAME + "/" + "SELF"];
    },
    currentLocale() {
      return i18nService.getActiveLanguage();
    },
  },

  methods: {
    async fetchLegalTexts(lang) {
      // legaltexteditor parent'inden lang gelecek - dil'e göre preview gösterimi
      if (!this.company?.id) {
        console.warn("Company ID not available yet");
        return;
      }

      this.loading = true;

      try {
        const url = `/api/company/${this.company.id}/legal-texts/resolve?keys[]=kvkk_notice&locale=${lang || this.currentLocale}`;
        const response = await axios.get(url);

        this.legalTextsData = response.data || {};
      } catch (error) {
        console.error("Error fetching legal texts:", error);
        this.legalTextsData = {};
      } finally {
        this.loading = false;
        this.openInformationUser();
      }
    },

    openInformationUser() {
      if (this.legalTextsData && Object.keys(this.legalTextsData).length > 0) {
        const modalElement = document.getElementById("informationForDynamic");
        const modal = UIkit.modal(modalElement);

        // Önceki event listener'ları temizle
        UIkit.util.off(modalElement, "hidden");

        // Modal kapanma event'ini dinle
        UIkit.util.on(modalElement, "hidden", () => {
          this.$emit("modal-closed");
        });

        modal.show();
        window.localStorage.setItem("informationText", "true");
      }
    },
  },

  beforeDestroy() {
    // Component destroy olurken event listener'ları temizle
    const modalElement = document.getElementById("informationForDynamic");
    if (modalElement) {
      UIkit.util.off(modalElement, "hidden");
    }
  },

  async mounted() {
    if (!window.localStorage.getItem("informationText")) {
      await this.fetchLegalTexts();
    }
  },

  watch: {
    company(newVal) {
      if (newVal?.id && Object.keys(this.legalTextsData).length === 0 && !this.loading) {
        this.fetchLegalTexts();
      }
    },
  },
};
</script>

<style scoped>
/* Loading spinner */
.py-5 {
  padding: 3rem 0;
}

.text-center {
  text-align: center;
}

.mt-3 {
  margin-top: 1rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

/* Legal sections - API'den gelen HTML için */
.legal-section {
  margin-bottom: 20px;
  font-size: 16px; /* Minimum font size */
}

.legal-section:deep(article) {
  padding: 0;
}

.legal-section:deep(p),
.legal-section:deep(span),
.legal-section:deep(div),
.legal-section:deep(li),
.legal-section:deep(a),
.legal-section:deep(address) {
  font-size: 16px;
}

/* VueEditor (Quill) Alignment Classes */
.legal-section:deep(.ql-align-center) {
  text-align: center;
}

.legal-section:deep(.ql-align-right) {
  text-align: right;
}

.legal-section:deep(.ql-align-justify) {
  text-align: justify;
}

.legal-section:deep(.ql-align-left) {
  text-align: left;
}

/* VueEditor (Quill) Indentation */
.legal-section:deep(.ql-indent-1) {
  padding-left: 3em;
}

.legal-section:deep(.ql-indent-2) {
  padding-left: 6em;
}

.legal-section:deep(.ql-indent-3) {
  padding-left: 9em;
}

.legal-section:deep(.ql-indent-4) {
  padding-left: 12em;
}

.legal-section:deep(.ql-indent-5) {
  padding-left: 15em;
}

.legal-section:deep(.ql-indent-6) {
  padding-left: 18em;
}

.legal-section:deep(.ql-indent-7) {
  padding-left: 21em;
}

.legal-section:deep(.ql-indent-8) {
  padding-left: 24em;
}

/* VueEditor (Quill) Font Sizes */
.legal-section:deep(.ql-size-small) {
  font-size: 16px; /* Minimum 16px */
}

.legal-section:deep(.ql-size-large) {
  font-size: 24px; /* 1.5x16 = 24px */
}

.legal-section:deep(.ql-size-huge) {
  font-size: 32px; /* 2x16 = 32px */
}

/* VueEditor (Quill) Font Families */
.legal-section:deep(.ql-font-serif) {
  font-family: Georgia, Times New Roman, serif;
}

.legal-section:deep(.ql-font-monospace) {
  font-family: Monaco, Courier New, monospace;
}

/* VueEditor (Quill) Text Formatting */
.legal-section:deep(strong) {
  font-weight: bold;
}

.legal-section:deep(em) {
  font-style: italic;
}

.legal-section:deep(u) {
  text-decoration: underline;
}

.legal-section:deep(s) {
  text-decoration: line-through;
}

.legal-section:deep(sub) {
  vertical-align: sub;
  font-size: smaller;
}

.legal-section:deep(sup) {
  vertical-align: super;
  font-size: smaller;
}

/* VueEditor (Quill) Code Block */
.legal-section:deep(pre) {
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  overflow-x: auto;
  font-family: Monaco, Courier New, monospace;
  font-size: 16px; /* Minimum 16px */
}

.legal-section:deep(code) {
  background-color: #f4f4f4;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: Monaco, Courier New, monospace;
  font-size: 16px; /* Minimum 16px */
}

/* VueEditor (Quill) Blockquote */
.legal-section:deep(blockquote) {
  border-left: 4px solid #ccc;
  margin: 15px 0;
  padding-left: 16px;
  color: #666;
  font-style: italic;
  font-size: 16px; /* Minimum 16px */
}

.legal-section:deep(h1) {
  font-size: 24px; /* 1.5x base size */
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
  text-align: center;
  border-bottom: 2px solid #8d8c8c;
  padding-bottom: 10px;
}

.legal-section:deep(h2) {
  font-size: 20px; /* 1.25x base size */
  font-weight: 600;
  color: #000000;
  margin-top: 25px;
  margin-bottom: 12px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ecf0f1;
}

.legal-section:deep(h3) {
  font-size: 18px; /* 1.125x base size */
  font-weight: 600;
  color: #000000;
  margin-top: 20px;
  margin-bottom: 10px;
}

.legal-section:deep(h4),
.legal-section:deep(h5),
.legal-section:deep(h6) {
  font-size: 16px; /* Minimum 16px */
  font-weight: 600;
  color: #000000;
  margin-top: 15px;
  margin-bottom: 8px;
}

.legal-section:deep(p) {
  margin-bottom: 15px;
  line-height: 1.6;
  color: #333;
}

.legal-section:deep(ul) {
  margin: 15px 0 15px 20px; /* Soldan 20px margin */
  padding-left: 40px; /* Sağdan başlasın */
  list-style-type: disc;
}

.legal-section:deep(ol) {
  margin: 15px 0 15px 20px; /* Soldan 20px margin */
  padding-left: 40px; /* Sağdan başlasın */
  list-style-type: decimal;
}

.legal-section:deep(li) {
  margin-bottom: 8px;
  line-height: 1.5;
}

.legal-section:deep(li::marker) {
  color: #000000;
  font-weight: bold;
}

/* VueEditor (Quill) List Alignment */
.legal-section:deep(ul.ql-align-center),
.legal-section:deep(ol.ql-align-center) {
  text-align: center;
  list-style-position: inside;
}

.legal-section:deep(ul.ql-align-right),
.legal-section:deep(ol.ql-align-right) {
  text-align: right;
  list-style-position: inside;
}

.legal-section:deep(ul.ql-align-justify),
.legal-section:deep(ol.ql-align-justify) {
  text-align: justify;
}

.legal-section:deep(address) {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  font-style: normal;
  margin: 20px 0;
}

.legal-section:deep(address strong) {
  color: #2c3e50;
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
}

.legal-section:deep(address a) {
  color: #2980b9;
  text-decoration: none;
}

.legal-section:deep(address a:hover) {
  text-decoration: underline;
}

.custom-list li {
  /* Yazı biraz büyük */
  margin-left: 16px;
  /* Sağa kaydırma */
  line-height: 1.6;
  /* Daha ferah satır aralığı */
}

.info-list {
  list-style-type: disc;
  /* klasik noktalar */
  margin-left: 20px;
  /* soldan 20px margin */
  padding-left: 40px;
  /* sağdan başlasın */
}

.info-list li {
  margin-bottom: 6px;
  /* her maddenin arasına boşluk */
}

/* Information Modal Styling */
.information-modal {
  max-width: 800px !important;
  width: 90vw !important;
}

.information-modal .uk-modal-body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px 30px;
}

.information-content {
  line-height: 1.6;
  color: #333;
  font-size: 16px; /* Base font size */
}

.document-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
  text-align: center;
  border-bottom: 2px solid #8d8c8c;
  padding-bottom: 10px;
}

.intro-text {
  background-color: #f8f9fa;
  padding: 15px;
  border-left: 4px solid #757272;
  margin-bottom: 25px;
  font-style: italic;
  border-radius: 4px;
}

.info-section {
  margin-bottom: 25px;
  padding: 15px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background-color: #fff;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #000000;
  margin-bottom: 12px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ecf0f1;
}

.section-subtitle {
  font-size: 1rem;
  font-weight: 500;
  color: #000000;
  margin-bottom: 10px;
  padding-bottom: 3px;
  border-bottom: 1px dashed #ecf0f1;
}

.info-list {
  margin: 15px 0 15px 20px; /* Soldan 20px margin */
  padding-left: 40px; /* Sağdan başlasın */
}

.info-list li {
  margin-bottom: 8px;
  line-height: 1.5;
  position: relative;
}

.info-list li::marker {
  color: #000000;
  font-weight: bold;
}

.contact-info {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #dee2e6;
}

.contact-info p {
  margin-bottom: 8px;
}

.contact-info a {
  color: #2980b9;
  text-decoration: none;
}

.contact-info a:hover {
  text-decoration: underline;
}

.company-info {
  text-align: center;
}

.company-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #000000;
  margin-bottom: 15px;
}

.contact-details {
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 0;
}

.contact-item i {
  color: #000000;
  margin-top: 2px;
  font-size: 1.1rem;
  min-width: 16px;
}

.contact-text {
  flex: 1;
}

.contact-text strong {
  color: #2c3e50;
  font-weight: 600;
}

.contact-text a {
  color: #000000;
  text-decoration: none;
}

.contact-text a:hover {
  text-decoration: underline;
}

.conclusion {
  background-color: #e8f4fd;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #b3d9ff;
  margin-top: 20px;
}

.conclusion p {
  margin-bottom: 10px;
}

.conclusion p:last-child {
  margin-bottom: 0;
  font-weight: 500;
}

/* Modal Header Styling */
.uk-modal-header {
  border-bottom: 2px solid #000000;
  padding: 20px 30px;
}

.uk-modal-title {
  color: #2c3e50;
  font-weight: 600;
  margin: 0;
}

/* Modal Footer Styling */
.uk-modal-footer {
  border-top: 1px solid #e9ecef;
  padding: 15px 30px;
}

/* Scrollbar Styling */
.uk-modal-body::-webkit-scrollbar {
  width: 8px;
}

.uk-modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.uk-modal-body::-webkit-scrollbar-thumb {
  background: #bfc1c2;
  border-radius: 4px;
}

.uk-modal-body::-webkit-scrollbar-thumb:hover {
  background: #969798;
}

/* Responsive Design */
@media (max-width: 768px) {
  .information-modal {
    width: 90vw !important;
    margin: 10px auto !important;
    max-height: 95vh;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }

  .information-modal .uk-modal-dialog {
    margin: 10px auto !important;
    max-height: 95vh;
    left: 0 !important;
    transform: none !important;
  }

  .information-modal .uk-modal-header {
    padding: 15px 20px;
    border-bottom: 1px solid #000000;
  }

  .information-modal .uk-modal-title {
    font-size: 1.1rem;
    text-align: center;
  }

  .information-modal .uk-modal-body {
    padding: 15px 20px;
    max-height: calc(95vh - 120px);
    overflow-y: auto;
  }

  .information-modal .uk-modal-footer {
    padding: 12px 20px;
    border-top: 1px solid #e9ecef;
  }

  .document-title {
    font-size: 1.1rem;
    margin-bottom: 15px;
    padding-bottom: 8px;
    text-align: center;
  }

  .intro-text {
    padding: 12px;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .info-section {
    padding: 12px;
    margin-bottom: 15px;
    border-radius: 6px;
  }

  .section-title {
    font-size: 1rem;
    margin-bottom: 10px;
    padding-bottom: 4px;
  }

  .section-subtitle {
    font-size: 0.95rem;
    margin-bottom: 8px;
    padding-bottom: 2px;
  }

  .info-list {
    margin: 12px 0 12px 15px; /* Soldan 15px margin (tablet için) */
    padding-left: 30px; /* Sağdan başlasın (tablet için) */
  }

  .info-list li {
    margin-bottom: 6px;
    font-size: 14px;
    line-height: 1.4;
  }

  .contact-info {
    padding: 12px;
    margin: 15px 0;
  }

  .company-name {
    font-size: 1rem;
    margin-bottom: 12px;
  }

  .contact-details {
    flex-direction: column !important;
    gap: 12px !important;
  }

  .contact-item {
    text-align: center;
    padding: 8px 0;
  }

  .contact-item i {
    font-size: 1rem;
    margin-right: 8px;
  }

  .contact-text {
    font-size: 14px;
  }

  .contact-text strong {
    font-size: 14px;
  }

  .conclusion {
    padding: 15px;
    margin-top: 15px;
  }

  .conclusion p {
    font-size: 14px;
    margin-bottom: 8px;
  }
}

@media (max-width: 480px) {
  .information-modal {
    width: 90vw !important;
    margin: 0 auto !important;
    max-height: 100vh;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }

  .information-modal .uk-modal-dialog {
    margin: 0 auto !important;
    max-height: 100vh;
    border-radius: 0;
    left: 0 !important;
    transform: none !important;
  }

  .information-modal .uk-modal-header {
    padding: 12px 15px;
  }

  .information-modal .uk-modal-title {
    font-size: 1rem;
  }

  .information-modal .uk-modal-body {
    padding: 12px 15px;
    max-height: calc(100vh - 100px);
  }

  .information-modal .uk-modal-footer {
    padding: 10px 15px;
  }

  .document-title {
    font-size: 1rem;
    margin-bottom: 12px;
  }

  .intro-text {
    padding: 10px;
    margin-bottom: 15px;
    font-size: 13px;
  }

  .info-section {
    padding: 10px;
    margin-bottom: 12px;
  }

  .section-title {
    font-size: 0.95rem;
    margin-bottom: 8px;
  }

  .section-subtitle {
    font-size: 0.9rem;
    margin-bottom: 6px;
  }

  .info-list {
    margin: 10px 0 10px 10px; /* Soldan 10px margin (mobil için) */
    padding-left: 25px; /* Sağdan başlasın (mobil için) */
  }

  .info-list li {
    margin-bottom: 5px;
    font-size: 13px;
  }

  .contact-info {
    padding: 10px;
    margin: 12px 0;
  }

  .company-name {
    font-size: 0.95rem;
    margin-bottom: 10px;
  }

  .contact-details {
    gap: 10px !important;
  }

  .contact-item {
    padding: 6px 0;
  }

  .contact-item i {
    font-size: 0.9rem;
    margin-right: 6px;
  }

  .contact-text {
    font-size: 13px;
  }

  .contact-text strong {
    font-size: 13px;
  }

  .conclusion {
    padding: 12px;
    margin-top: 12px;
  }

  .conclusion p {
    font-size: 13px;
    margin-bottom: 6px;
  }
}

@media (max-width: 360px) {
  .information-modal {
    left: 50% !important;
    transform: translateX(-50%) !important;
  }

  .information-modal .uk-modal-dialog {
    left: 0 !important;
    transform: none !important;
  }

  .information-modal .uk-modal-header {
    padding: 10px 12px;
  }

  .information-modal .uk-modal-title {
    font-size: 0.95rem;
  }

  .information-modal .uk-modal-body {
    padding: 10px 12px;
  }

  .information-modal .uk-modal-footer {
    padding: 8px 12px;
  }

  .document-title {
    font-size: 0.95rem;
  }

  .intro-text {
    padding: 8px;
    font-size: 12px;
  }

  .info-section {
    padding: 8px;
  }

  .section-title {
    font-size: 0.9rem;
  }

  .section-subtitle {
    font-size: 0.85rem;
  }

  .info-list li {
    font-size: 12px;
  }

  .contact-text {
    font-size: 12px;
  }

  .contact-text strong {
    font-size: 12px;
  }

  .conclusion p {
    font-size: 12px;
  }
}

/* Legacy styles for other modals */
.legacy__page-content_detail h3 {
  color: #2c3e50;
  font-weight: 600;
  margin: 20px 0 15px 0;
  border-bottom: 1px solid #ecf0f1;
  padding-bottom: 5px;
}

.legacy__page-content_detail p {
  margin-bottom: 15px;
  line-height: 1.6;
}

.legacy__page-content_detail ul {
  margin: 15px 0 15px 20px; /* Soldan 20px margin */
  padding-left: 40px; /* Sağdan başlasın */
}

.legacy__page-content_detail li {
  margin-bottom: 8px;
  line-height: 1.5;
}

.legacy__page-content_detail strong {
  color: #000000;
  font-weight: 600;
}

.legacy__page-content_detail a {
  color: #2980b9;
  text-decoration: none;
}

.legacy__page-content_detail a:hover {
  text-decoration: underline;
}
</style>